<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Hardware Security Chain';
                }
            },
            component_id: {
                default(){
                    return 'hardware_security_chain';
                }
            },
            hardwareColour: {
                required: true
            },
            securedByDesign: {
                required: true
            },
            doorRange: {
                required: true
            },
            doorLocation: {
                required: false,
                default(){
                    return '0';
                }
            },
            extra_text: {
              default(){
                return false;
              }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.hardwareColour, this.securedByDesign, this.doorRange);
            },
            thumbURL(){
                return '/thumb/hardware/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-security-chain?hardware_colour=' + this.hardwareColour + '&secured_by_design=' + this.securedByDesign + '&door_range=' + this.doorRange + '&door_location=' + this.doorLocation;
            },
            cache_key(){
                return '_' + this.hardwareColour + '_' + this.securedByDesign + '_' + this.doorRange + '_' + this.doorLocation;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
